import Inspector from './inspector';
const { InnerBlocks, RichText } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const {
    containerized,
    margin,
    contentPosition,
    variant,
    background,
    sideImage,
    withFigcaption,
    figcaption,
    imagePosition,
    titleFull,
    titleAfterImage,
    padding,
  } = attributes;

  const ALLOWED_BLOCKS = [
    'base/heading-sumicity',
    'base/paragraph-sumicity',
    'app/topics',
    'base/button-sumicity',
  ];

  const staticDefaultImage = 'https://via.placeholder.com/250x350?text=Imagem';

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section
        className={`ImageWithTopics ${margin} ${variant} ${background} wp-editor `}
      >
        <div
          className={`${
            containerized ? 'Container' : ''
          } Container-block-pd-${padding}`}
        >
          <div
            className={`ImageWithTopics__content ${contentPosition} ${
              titleFull && 'title-full'
            }  ${titleAfterImage && 'title-after'}`}
          >
            <figure
              className={`
                ImageWithTopics__content--img
                ${contentPosition}
                ${imagePosition}
                ${withFigcaption ? 'with-figcaption' : ''}
              `}
            >
              <img src={sideImage.src || staticDefaultImage} />

              {withFigcaption && (
                <RichText
                  tagName="figcaption"
                  className={`Typography text color-black margin-none`}
                  value={figcaption}
                  placeholder="Texto Mobile (tag figcaption)"
                  keepPlaceholderOnFocus
                  onChange={(figcaption) => setAttributes({ figcaption })}
                />
              )}
            </figure>

            <InnerBlocks allowedBlocks={ALLOWED_BLOCKS} />
          </div>
        </div>
      </section>
    </>
  );
};

export default Edit;
